import { useCurrentUser } from '@utils/useCurrentUser'
import { FormattedMessage } from 'react-intl'
import { Box } from '@mui/material'
import React from 'react'
import { Linq } from '@src/components/Linq'
import countriesMap from '@localization/countries.json'
import { useCheckMMUserCountry } from '@utils/useCheckUserCountry'

interface JapanMMViewFAQProps {
  className?: string
}

const JapanMMViewFAQ: React.FC<JapanMMViewFAQProps> = ({ className }) => {
  const { userIsLoggedIn } = useCurrentUser()
  const isJapanMMUser = useCheckMMUserCountry(countriesMap.JP.countryCode)

  if (!userIsLoggedIn || !isJapanMMUser) return null

  return (
    <Box fontSize={12} className={className}>
      <FormattedMessage
        id="CONTACT_LOCAL_DEALER_MM"
        defaultMessage="For delivery times and prices contact your dealer."
      />{' '}
      <Linq href="/life-science/ecommerce/ecommerce-faq/ordering-delivery-price">
        <FormattedMessage id="VIEW" defaultMessage="View" />{' '}
        <FormattedMessage id="FAQ" defaultMessage="FAQ" />
      </Linq>
    </Box>
  )
}

export default JapanMMViewFAQ
